/**
 * @desc 保存合作企业
 */
import { BrandEntity, BrandForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateBrandParameter = BrandForm

const method = 'POST'
const url = '/content/operation/brand'

export const createBrandApi = (
  data?: CreateBrandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BrandEntity>({
    method,
    url,
    data,
    ...config
  })
}

createBrandApi.method = method
createBrandApi.url = url
